<script setup lang="ts">
defineProps<{
  description?: string
  hdr?: boolean
}>()
</script>

<template>
  <div class="album-item-overlay">
    <BlogUiTooltip :content="description || '暂无描述'">
      <p>
        <span v-if="hdr" class="album-item-hdr">HDR</span>
        {{ description || '暂无描述' }}
      </p>
    </BlogUiTooltip>
  </div>
</template>

<style scoped>
.album-item-overlay {
  position: absolute;
  z-index: 2;
  inset: auto 0 0;
  padding: 16px 12px 12px;
  background: linear-gradient(
    180deg,
    rgba(10, 16, 24, 0) 0%,
    rgba(10, 16, 24, 0.24) 38%,
    rgba(10, 16, 24, 0.58) 72%,
    rgba(10, 16, 24, 0.78) 100%
  );
  backdrop-filter: blur(1px);
}

.album-item-overlay p {
  margin-top: 0;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.86);
  font-size: 13px;
  line-height: 1.55;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.album-item-hdr {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  padding: 2px 5px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.04em;
  vertical-align: 1px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 3px;
}

@media (hover: none) and (pointer: coarse) {
  .album-item-overlay {
    pointer-events: none;
  }
}
</style>
